/* eslint-disable no-unused-vars */
import React, { Fragment, useState } from 'react'
import ElementContainer from '../ElementContainer'
import {
  Box,
  Button,
  ButtonBase,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Menu,
  MenuItem,
  Typography
} from '@mui/material'
import imagePlaceholder from '../../../assets/images/imagePlaceholder.png'
import { photosElementStyles } from '../../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'
import InfoIcon from '@mui/icons-material/Info'
import { cloneDeep } from '../../../utils/formBuilder'
import { menuProps } from '../../../styles/mui_custom_theme'

const PhotosElement = ({
  title,
  helpfulHint,
  answer,
  onChangeValue,
  photos,
  isMandatory,
  isPreviewMode,
  disabled
}) => {
  const [photosArray, setPhotosArray] = useState(answer || [])
  const originalTitles = [...photos.map(photo => photo.title)]
  let selectedTitles = []
  const totalMandatoryPhotos = photos.filter(photo => photo.required).length
  let selectedMandatoryPhotos = 0
  if (photosArray) {
    selectedTitles = photosArray.map(photo => {
      const originalPhoto = photos.find(photoItem => photoItem.title === photo.title)
      if (originalPhoto.required) selectedMandatoryPhotos++
      return photo.title
    })
  }
  const photoTitles = []
  originalTitles.forEach(title => {
    if (!selectedTitles.includes(title)) photoTitles.push(title)
  })
  const [selectedTitle, setSelectedTitle] = useState(null)
  const { classes } = photosElementStyles()
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const imageChangeHandler = e => {
    const files = [...e.target.files]
    const file = files[0]
    const imageUrl = URL.createObjectURL(file)
    const objectToSave = { title: selectedTitle, url: imageUrl }
    if (photosArray) {
      const foundImageIndex = photosArray.findIndex(
        photo => photo.title === selectedTitle
      )
      if (foundImageIndex === -1) {
        setPhotosArray(prev => [...prev, objectToSave])
        onChangeValue([...photosArray, objectToSave])
      } else {
        const newAnswer = cloneDeep(photosArray)
        newAnswer[foundImageIndex] = objectToSave
        setPhotosArray(newAnswer)
        onChangeValue(newAnswer)
      }
    } else {
      setPhotosArray([objectToSave])
      onChangeValue([objectToSave])
    }
    setSelectedTitle(null)
  }

  const imageChangeHandlerAlt = (e, currentTitle) => {
    const files = [...e.target.files]
    const file = files[0]
    const imageUrl = URL.createObjectURL(file)
    const objectToSave = { title: currentTitle, url: imageUrl }
    if (photosArray) {
      const foundImageIndex = photosArray.findIndex(
        photo => photo.title === currentTitle
      )
      if (foundImageIndex === -1) {
        onChangeValue([...photosArray, objectToSave])
      } else {
        const newAnswer = cloneDeep(photosArray)
        newAnswer[foundImageIndex] = objectToSave
        onChangeValue(newAnswer)
      }
    } else {
      onChangeValue([objectToSave])
    }
    handleClose()
  }

  const imageInput = () => {
    return (
      <input
        hidden
        accept="image/png, image/jpeg, image/jpg, image/bitmap"
        type="file"
        onChange={imageChangeHandler}
        loading="lazy"
      />
    )
  }

  const imageInputAlt = title => {
    return (
      <input
        hidden
        accept="image/png, image/jpeg, image/jpg, image/bitmap"
        type="file"
        onChange={e => imageChangeHandlerAlt(e, title)}
        loading="lazy"
      />
    )
  }

  const changeSelectHandler = title => {
    setSelectedTitle(title)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const missingPhotos = totalMandatoryPhotos - selectedMandatoryPhotos
  let buttonLabel = t('mobile_preview.add')
  if (photosArray && missingPhotos > 0) {
    if (missingPhotos === 1) {
      buttonLabel = t('mobile_preview.photos.photo_required')
    } else {
      buttonLabel = t('mobile_preview.photos.photos_required', {
        number: missingPhotos
      })
    }
  }

  return (
    <Fragment>
      <ElementContainer
        title={title}
        helpfulHint={helpfulHint}
        isMandatory={isMandatory}
      >
        <Box className={classes.imagesContainer}>
          {!photosArray?.length && (
            <Button
              disabled={disabled}
              disableRipple
              className={classes.buttonImagePlaceholder}
              onClick={handleClick}
            >
              <img
                className={classes.imagePlaceholder}
                src={imagePlaceholder}
                loading="lazy"
              />
              <Typography className={classes.inImagePlaceholderText}>
                {totalMandatoryPhotos > 0 &&
                  t('mobile_preview.photos.photos_required', {
                    number: totalMandatoryPhotos
                  })}
              </Typography>
              {imageInput()}
            </Button>
          )}
          {photosArray?.length > 0 && (
            <ImageList>
              {photosArray.map((image, index) => (
                <ImageListItem key={index}>
                  <img src={image?.url} />
                  <ImageListItemBar
                    title={image.title}
                    actionIcon={
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${image.title}`}
                        component="label"
                        disabled={disabled}
                      >
                        {imageInputAlt(image.title)}
                        <InfoIcon />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </Box>
        {!(photoTitles.length === 0) && !isPreviewMode && (
          <Box className={classes.addButtonContainer}>
            <Box className={classes.addButton} onClick={disabled ? undefined : handleClick}>
              <Typography
                className={`${classes.addButtonText} ${
                  (photosArray && missingPhotos > 0) && classes.addButtonTextRed
                }`}
              >
                {buttonLabel}
              </Typography>
            </Box>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={menuProps}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              {photoTitles.map((option, index) => {
                return (
                  <MenuItem
                    className={classes.menuItems}
                    key={`${option}-${index}`}
                    onClick={() => changeSelectHandler(option)}
                    disabled={disabled}
                  >
                    <ButtonBase
                      fullWidth
                      className={classes.menuButton}
                      component="label"
                    >
                        {option}
                      {imageInput()}
                    </ButtonBase>
                  </MenuItem>
                )
              })}
            </Menu>
          </Box>
        )}
      </ElementContainer>
    </Fragment>
  )
}

export default PhotosElement
